angular.module('LeasePilot').factory('BuildingService', [
  'railsResourceFactory',
  function(railsResourceFactory) {
    return railsResourceFactory({
      url: '/api/buildings',
      name: 'building',
    });
  },
]);
